export default __webpack_public_path__ + "static/media/contractofprotection.cd06289b.png";